import { Link } from "react-router-dom";
import { Gift, ChevronRight } from "lucide-react";
import { useLanguage, type Lang } from "@/context/LanguageContext";
import { localizedPath } from "@/lib/url-slugs";
import giftCardImg from "@/assets/gift-card.png";

const COPY: Record<Lang, { badge: string; title: string; subtitle: string; cta: string; from: string }> = {
  lv: {
    badge: "Jaunums",
    title: "Dāvanu karte",
    subtitle: "Ideāla dāvana ikvienam padel entuziastam. Saņēmējs pats izvēlas sev tīkamāko ekipējumu.",
    cta: "Iegādāties dāvanu karti",
    from: "No €30",
  },
  en: {
    badge: "New",
    title: "Gift Card",
    subtitle: "The perfect gift for any padel enthusiast. Let them choose their own gear.",
    cta: "Buy a Gift Card",
    from: "From €30",
  },
};

const GiftCardSection = () => {
  const { lang } = useLanguage();
  const copy = COPY[lang];

  return (
    <section className="container mx-auto px-4 py-10 md:py-14">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary via-green-dark to-primary p-8 md:p-12">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-accent/10 -translate-y-1/2 translate-x-1/3" />
        <div className="absolute bottom-0 left-0 w-40 h-40 rounded-full bg-accent/5 translate-y-1/2 -translate-x-1/4" />

        <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
          {/* Left: Image */}
          <div className="w-full md:w-72 shrink-0">
            <img
              src={giftCardImg}
              alt="Padel Corner Dāvanu Karte"
              className="w-full rounded-xl shadow-lg"
              loading="lazy"
            />
          </div>

          {/* Right: Text + CTA */}
          <div className="flex-1 text-center md:text-left">
            <span className="inline-block bg-accent/20 text-accent text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wider">
              {copy.badge}
            </span>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-primary-foreground mb-3">
              {copy.title}
            </h2>
            <p className="text-primary-foreground/75 text-base max-w-md mb-6">
              {copy.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <Link
                to={localizedPath(lang, "giftCard")}
                className="inline-flex items-center gap-2 bg-accent text-accent-foreground font-semibold px-7 py-3.5 rounded-xl shadow-lg hover:bg-accent/90 hover:shadow-xl hover:scale-[1.03] transition-all duration-300"
              >
                {copy.cta}
                <ChevronRight size={18} />
              </Link>
              <span className="text-primary-foreground/60 text-sm font-semibold">{copy.from}</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default GiftCardSection;
